<template>
  <div class="box-card">
    <div class="chartTop" v-if="!!title">
      <div class="metaWrap">
        <div class="meta">
          <span class="title">{{title}}</span>
          <span class="action">
              <slot name="action" ></slot>
            </span>
        </div>
      </div>
    </div>
    <div class="content">
      <slot name="content"></slot>
    </div>
    <div class="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
  .chartCard {
    position: relative;
  }
  .chartTop {
    position: relative;
    width: 100%;
    overflow: hidden;
  }
  .metaWrap {
    float: left;
  }
  .action {
    position: absolute;
    top: 4px;
    right: 0;
    line-height: 1;
    cursor: pointer;
  }
  .meta {
    height: 22px;
    color: rgba(0, 0, 0, .45);
    font-size: 14px;
    line-height: 22px;
  }
  .title{
    font-size:18px;
    font-weight:400;
    color:rgba(68,68,68,1);
    line-height:25px;
  }

  .content {
    position: relative;
    width: 100%;
    margin-bottom: 12px;
  }
  .contentFixed {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .footer {
    margin-top: 8px;
    padding-top: 14px;
    border-top: 1px solid #e8e8e8;
    & > * {
      position: relative;
    }
  }
</style>
<script>

export default {

  data() {
    return {

    }
  },
  props: {
    loading: Boolean,
    title: {
      type: String,
      default: ''
    }
  },
  methods: {

  },
  mounted() {
  }
}
</script>
